function formatTimestamp(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor(totalSeconds / 60) - hours * 60

  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')

  const suffix = hours <= 0 ? 'm' : 'h'

  return `${formattedHours}:${formattedMinutes}${suffix}`
}

export { formatTimestamp }
